<template>
  <div
    class="btn-group-spaced"
    :class="{ 'is-justified': isMonthMode }"
  >
    <AppButton
      v-for="day in availableDays"
      :key="day.value"
      class="btn-sm btn-default"
      :class="{ active: isDaySelected(day), 'btn-circle': isWeekMode, 'btn-rounded': isMonthMode }"
      :disabled="disabled"
      @click="toggleDay(day)"
    >
      {{ day.name }}
    </AppButton>
  </div>
</template>

<script>
import VModelCompat from '~/mixins/v_model_compat';

const WEEK_DAYS = [
  { name: 'Su', value: 0 },
  { name: 'Mo', value: 1 },
  { name: 'Tu', value: 2 },
  { name: 'We', value: 3 },
  { name: 'Th', value: 4 },
  { name: 'Fr', value: 5 },
  { name: 'Sa', value: 6 },
];
const MONTH_DAYS = [
  { name: 'First day of the month', value: 0 },
  { name: '15th of the month', value: 1 },
  { name: 'Last day of the month', value: 2 },
];

// Supports both the legacy Vue 2 API (`:value` + `@input`) and Vue 3 `v-model`
// (`modelValue` + `update:modelValue`) via the VModelCompat mixin — consumers use both styles.
// Emitting only `input` made `v-model="form.days"` never update (selection looked active but the
// submitted payload had no days).
export default {
  name: 'AppIntervalDayPicker',
  mixins: [VModelCompat],
  props: {
    modelValue: {
      type: Array,
      default: undefined,
    },
    mode: {
      type: String,
      default: 'week',
    },
    multiple: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentValue: [],
    };
  },
  computed: {
    availableDays() {
      if (this.isWeekMode) {
        return WEEK_DAYS;
      }
      if (this.isMonthMode) {
        return MONTH_DAYS;
      }

      return [];
    },
    availableDaysValues() {
      return this.availableDays.map((day) => day.value);
    },
    isWeekMode() {
      return this.mode === 'week';
    },
    isMonthMode() {
      return this.mode === 'month';
    },
  },
  watch: {
    modelCompatValue() {
      this.processValue();
    },
  },
  created() {
    this.processValue();
  },
  methods: {
    processValue() {
      this.currentValue = this.modelCompatValue ? this.filterValidDays(this.modelCompatValue) : [];
    },
    toggleDay(day) {
      if (!this.isDaySelected(day)) {
        this.selectDay(day);
      } else {
        this.deselectDay(day);
      }
    },
    deselectDay(day) {
      const index = this.currentValue.indexOf(day.value);

      this.currentValue.splice(index, 1);
      this.onChange();
    },
    selectDay(day) {
      if (this.multiple) {
        this.currentValue.push(day.value);
      } else {
        this.currentValue = [day.value];
      }

      this.onChange();
    },
    isDaySelected(day) {
      return this.currentValue.indexOf(day.value) >= 0;
    },
    filterValidDays(values) {
      return values.map(Number).filter((value) => {
        return this.availableDaysValues.includes(value);
      });
    },
    onChange() {
      this.emitModelCompatValue(this.currentValue);
    },
  },
};
</script>
